<div class="order-item-container">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="type">نوع:‌ {{ getType() }}</div>
    <div class="price">
      <div class="span" *ngIf="+orderObject.price !== 0">
        {{ orderObject.price | digitsEnToFa }} تومان
      </div>
    </div>
  </div>

  <div class="content" *ngIf="orderObject.type !== 'thesis-edit'">
    <div
      class="information"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="info" fxFlex="100" fxLayoutAlign="row wrap">
        <span class="pages-number">
          {{ this.orderObject.pageCount + " صفحه" | digitsEnToFa }}/
        </span>
        <span class="bw-pages-number" *ngIf="bwBlocks && bwBlocks.length > 0">
          {{ bwBlocks.length + "صفحه سیاه و سفید" | digitsEnToFa }}
        </span>
        <span
          class="colorful-pages-number"
          *ngIf="colorFulBlocks && colorFulBlocks.length > 0"
        >
          {{ colorFulBlocks.length + "صفحه تمام رنگی" | digitsEnToFa }}/
        </span>

        <span
          class="halfColorful-pages-number"
          *ngIf="halfColorBlocks && halfColorBlocks.length > 0"
        >
          {{ halfColorBlocks.length + "صفحه نیمه رنگی" | digitsEnToFa }}/
        </span>

        <span class="binding" *ngIf="orderObject.binding">
          {{ orderObject.binding.name }}
        </span>
      </div>
    </div>
  </div>

  <div
    class="actions-status"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div class="status" [ngClass]="orderObject.status">
      {{ getDisplayStatus() }}
    </div>
  </div>
</div>
